import axios from '../axios'

const putLessonApi = async (lessonId, payload) => {
  return await axios.put(`api/lms/lessons/${lessonId}`, payload)
}

export default putLessonApi
